import React, { useContext, Fragment } from 'react';
import { AuthStore } from './providers/auth';
import PrivateRoutes from './routes/private';
import PublicRoutes from './routes/public';

function AppContent() {
  const [{ user, init }] = useContext(AuthStore) || [];

  return (
    <Fragment>
      {init && <div>Loading...</div>}

      <PublicRoutes />
      {user && <PrivateRoutes />}
    </Fragment>
  );
}

export default AppContent;
